import logo from "./logos/SVC-Chamber-Color-75-years-transparent.png";
import Image from "next/image";
import "./styles.scss";

const SiliconValleyLogo = () => {
  return (
    <>
      <div id="mni-membership-638315552356865376">
        <div className="mn-widget-member">
          <div className="mn-widget-member-name">Form Genius LLC.</div>
          <div className="mn-widget-member-text">Proud Member of</div>
          <div className="mn-widget-member-assoc">
            <a
              href="https://members.svcentralchamber.com/list/member/form-genius-llc-21117"
              target="_blank"
              className="mn-widget-member-link"
              rel="noreferrer">
              <Image
                src={logo}
                width={100}
                height={100}
                alt="Silicon Valley Central Chamber"
                title="Silicon Valley Central Chamber"
                className="mn-widget-member-logo"
              />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default SiliconValleyLogo;
